<template>
  <div class="card pa1">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'bh-card'
}
</script>

<style scoped>
.card {
  background: #FFFFFF;
  box-shadow: 0px 3px 16px #0A4B6D2E;
  border-radius: 7px;
  opacity: 0.73;
}
</style>
